module.exports = __webpack_public_path__ + "img/image6.220d8f5d.png";